import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { User, Mail, Calendar, Shield, UserCircle } from 'lucide-react';

export default function ProfilesPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  const getRoleColor = (role) => {
    switch(role) {
      case 'super_admin': return 'bg-purple-500/20 text-purple-400';
      case 'manager': return 'bg-blue-500/20 text-blue-400';
      case 'agent': return 'bg-green-500/20 text-green-400';
      case 'partner': return 'bg-yellow-500/20 text-yellow-400';
      default: return 'bg-gray-500/20 text-gray-400';
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-cyan-400 flex items-center gap-2">
        <UserCircle size={24} />
        Profils ({data.length})
      </h2>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.map(profile => (
            <div key={profile.id} className="bg-gray-900 rounded-xl border border-gray-800 p-5 hover:border-cyan-500/50 transition">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                  <User size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="text-white font-medium text-lg">{profile.full_name}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-xs ${getRoleColor(profile.role)}`}>
                    {profile.role}
                  </span>
                </div>
              </div>
              
              <div className="space-y-2 text-sm">
                <p className="text-gray-400 flex items-center gap-2">
                  <Mail size={14} className="text-gray-500" />
                  <a href={`mailto:${profile.email}`} className="hover:text-cyan-400">
                    {profile.email}
                  </a>
                </p>
                <p className="text-gray-500 text-xs flex items-center gap-1">
                  <Calendar size={12} />
                  Membre depuis: {new Date(profile.created_at).toLocaleDateString()}
                </p>
                {profile.created_by && (
                  <p className="text-gray-500 text-xs flex items-center gap-1">
                    <Shield size={12} />
                    Créé par: {profile.created_by.substring(0, 8)}...
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}